import Tooltip from "../../../../components/tooltip";
// import Simulation from "./Generation/SimulationPPEConsole";
import SurplusDeficitAnalysis from "./Generation/OptimalDeficit";
import { useCallback, useEffect, useState } from "react";
import { useOptimizerNavigation } from "../utility/useOptimizerNavigation";
import { ErrorPopup } from "../../../../components/ErrorHandling";
import DateRangeSelector from "../DateRange/DateRangeSelector";
import { useSelector } from "react-redux";
import Loading from "../../../../components/Loading";
import ToggleTabs from "../utility/ChartTableToggle";
import GnaMetricsCostAnalysis from "./Generation/GnaMetrics/GnaMetricsCost";
import GnaMetricsVolumeAnalysis from "./Generation/GnaMetrics/GnaMetricsVolume";
import { fetchProcurementSimulationMetricsData } from "../../../../Rest_api/RestApi";
const DataTabs = ["Volume", "Cost"];
const MainTabs = ["Simulation", "Optimal", "Metrics"];

export default function RuvnlSimulationIndex({ refreshKey }: { refreshKey: number }) {
  const { navigateToPage } = useOptimizerNavigation();
  const [activeMainTab, setActiveMainTab] = useState(MainTabs[0]);
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [uniqueTargetDate, setUniqueTargetDate] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);

  const preSelectedstartDate = useSelector(
    (state: any) => state.ProcurementOptimizerGridcoDate.startDate
  );
  const preSelectedendDate = useSelector(
    (state: any) => state.ProcurementOptimizerGridcoDate.endDate
  );
  const [selectedTargetDate, setSelectedTargetDate] = useState<
    Array<{ value: string; label: string; isFixed: boolean }>
  >([]);
  const handleDateChange = (
    start: Date | null,
    end: Date | null,
    allDates: Array<{ value: string; label: string; isFixed: boolean }>
  ) => {
    setSelectedTargetDate(allDates);
  };

  const handleFetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetchProcurementSimulationMetricsData();
      const res = [response];
      setData(res);
    } catch (error) {
      console.error("Error fetching data", error);
      setError?.("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  }, [setError]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData, refreshKey]);

  return (
    <>
      <div className="flex flex-col h-full w-full min-w-0 overflow-hidden">
        {/* Header with Date Range and Tabs - Fixed height */}
        <div className="flex justify-between items-center mb-3 border-b border-[#DFEAF2] pb-2 flex-shrink-0 min-w-0">
          <div className="flex items-center gap-3 min-w-0">
            <DateRangeSelector
              placeholder="Select Date Range"
              startDate={preSelectedstartDate}
              endDate={preSelectedendDate}
              onDateChange={handleDateChange}
            />
          </div>
          <div className="flex gap-x-6 justify-end flex-shrink-0">
            <ToggleTabs
              tabs={DataTabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>
        </div>

        {/* Content area - Takes remaining height */}
        <div className="flex flex-col gap-3 flex-1 min-h-0 min-w-0 overflow-hidden">
          {/* Metrics Cards Row - Auto height based on content */}
          <div className="w-full flex-shrink-0 min-w-0 overflow-hidden">
            {activeTab === "Volume" && (
              <GnaMetricsVolumeAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                loading={loading}
                data={data}
              />
            )}
            {activeTab === "Cost" && (
              <GnaMetricsCostAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                loading={loading}
                data={data}
              />
            )}
          </div>

          {/* Charts Row - Takes remaining space */}
          <div className="w-full flex-1 min-h-0 min-w-0 overflow-hidden">
            {activeTab === "Volume" && (
              <SurplusDeficitAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                setUniqueTargetDate={setUniqueTargetDate}
                selectedTargetDate={selectedTargetDate}
                activeTab={activeTab}
              />
            )}
            {activeTab === "Cost" && (
              <SurplusDeficitAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                setUniqueTargetDate={setUniqueTargetDate}
                selectedTargetDate={selectedTargetDate}
                activeTab={activeTab}
              />
            )}
          </div>
        </div>
      </div>

      <ErrorPopup error={error} onClose={() => setError(null)} />
    </>
  );
}
